module.exports = __webpack_public_path__ + "static/media/1.f5c976d0.jpg";